import React from 'react';
import styled from 'styled-components/macro';

const Wrapper = styled.div`
  width: 100%;
  padding: 0;
  text-align: center;
  overflow: hidden;

  span {
    display: inline-block;
    opacity: 0;
  }

  @keyframes speed {
    0% {
      opacity: 0;
      transform: translateX(-40px);
    }

    33% {
      opacity: 1;
      transform: translateX(0);
    }

    66% {
      opacity: 1;
      transform: translateX(0);
    }

    100% {
      opacity: 0;
      transform: translateX(40px);
    }
  }

  span:nth-child(6) {
    animation: speed 1.5s infinite ease-in-out;
  }

  span:nth-child(5) {
    animation: speed 1.5s 100ms infinite ease-in-out;
  }

  span:nth-child(4) {
    animation: speed 1.5s 200ms infinite ease-in-out;
  }

  span:nth-child(3) {
    animation: speed 1.5s 300ms infinite ease-in-out;
  }

  span:nth-child(2) {
    animation: speed 1.5s 400ms infinite ease-in-out;
  }

  span:nth-child(1) {
    animation: speed 1.5s 500ms infinite ease-in-out;
  }
`;

function ButtonLoader() {
  return (
    <Wrapper>
      <span>●</span>
      <span>●</span>
      <span>●</span>
      <span>●</span>
    </Wrapper>
  );
}

export default ButtonLoader;
